import { CommonModule, Location, NgComponentOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { H1Component, H2Component, PmLinkComponent } from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import { LucideArrowLeft } from '@lucide/angular';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { BasicLayoutHelperService } from '../basic-layout-helper.service';
import { ResponsiveCardGridDirective } from '@core/directives/responsive-card-grid.directive';

@Component({
  selector: 'pm-page-heading',
  templateUrl: './page-heading.component.html',
  imports: [
    TranslateModule,
    NgComponentOutlet,
    CommonModule,
    InlineSVGModule,
    MatSelectModule,
    PmLinkComponent,
    H2Component,
    H1Component,
    ResponsiveCardGridDirective,
  ],
})
export class PageHeadingComponent {
  protected basicLayoutHelperService = inject(BasicLayoutHelperService);
  protected location = inject(Location);

  arrowLeftIcon = LucideArrowLeft;

  isHomePage = input(false);

  protected headerComponent = computed(() => {
    const selectedNavItem = this.basicLayoutHelperService.selectedNavItem();
    if (!selectedNavItem || !selectedNavItem.headerComponent) {
      return null;
    }
    // case when the header component should be shown (even on subpaths)
    if (selectedNavItem.headerComponent.hideOnSubpath === false) {
      return selectedNavItem.headerComponent.component;
    }

    const currentPathname = this.basicLayoutHelperService.currentPathname();
    return currentPathname === selectedNavItem.routerLink
      ? selectedNavItem.headerComponent.component
      : null;
  });

  protected headingTestId = computed(() => {
    const selectedNavItem = this.basicLayoutHelperService.selectedNavItem();
    if (!selectedNavItem) {
      return undefined;
    }
    // Generate a test ID based on the nav item ID
    return `${selectedNavItem.id}-heading`;
  });
}
